import { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography, Spin, Result } from 'antd';
import './AdminApprovalPage.css';
import NewLogo from "../assests/images/collab_ai_logo_white_new.png";

const { Title } = Typography;

const AdminApprovalPage = () => {
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('pending');
  const { search } = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(search);
  const orgId = queryParams.get('orgId');
  const action = queryParams.get('action');

  useEffect(() => {
    const approveOrReject = async () => {
      try {
        const response = await axios.get( 
          `${process.env.REACT_APP_BASE_URL}api/company/admin/verify-organization?orgId=${orgId}&action=${action}`
        );
        setMessage(response.data.message);
        setStatus('success');
      } catch (error) {
        setMessage('Something went wrong. Please try again later.');
        setStatus('error');
      }
    };

    if (orgId && action) {
      approveOrReject();
    }
  }, [orgId, action]);

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <div className='admin-approval-page'>
      <div className="admin-card">
        <div className="admin-header">
          <img
            src={NewLogo}
            alt="Collab AI Logo"
            className="admin-logo"
            onClick={handleLogoClick}
            style={{ cursor: 'pointer'}}
          />
        </div>
        <div className="admin-content">
          {status === 'pending' ? (
            <Spin size="large" />
          ) : (
            <Result
              status={status}
              title={<Title level={4} className="admin-title">Approval Statusss</Title>}
              subTitle={<p className="admin-message">{message}</p>}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminApprovalPage;
